import { Injectable } from '@angular/core';

import { TechSnackbarComponent } from './techsnackbar/techsnackbar.component';
import { TechErrorDialogModel } from './techerrordialog/techerror_dialog.model';
import { TechErrorDialogComponent } from './techerrordialog/techerror_dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TechModalDialogModel } from './techmodaldialog/techmodaldialog.model';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { TechConfirmationDialogComponent } from './techconfirmationdialog/techconfirma_dialog.component';
import { TechModalDialogComponent } from './techmodaldialog/techmodaldialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import {
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBarRef,
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';
import { CommonService } from '@tech-services/common.service';

@Injectable({
  providedIn: 'root',
})
export class TechDialogsService {
  //actionButtonLabel: string = 'Retry';
  //action: boolean = true;
  //addExtraClass: boolean = false;
  setAutoHide: boolean = true;
  autoHide: number = 2000;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  dialogRef: MatSnackBarRef<TechSnackbarComponent>;
  dialogRefConfirmation: MatDialogRef<TechConfirmationDialogComponent>;
  public displayedModal = false;

  constructor(public snackBar: MatSnackBar, public dialog: MatDialog) {}

  //TechSnackBar
  public openSnackBar(message) {
    let cfg = new MatSnackBarConfig();
    cfg.verticalPosition = this.verticalPosition;
    cfg.horizontalPosition = this.horizontalPosition;
    cfg.duration = this.setAutoHide ? this.autoHide : 0;
    cfg.data = {
      html: message,
    };
    //cfg.extraClasses = this.addExtraClass ? ['test'] : undefined;
    //this.snackBar.open(message, this.action ? this.actionButtonLabel : undefined, cfg);
    this.snackBar.openFromComponent(TechSnackbarComponent, cfg);
  }

  //TechErrorDialog
  public openErrorDialog(error: HttpErrorResponse): boolean {
    let dialogErrorData = new TechErrorDialogModel();
    if (error) {
      dialogErrorData.code = error.error.Code;
      dialogErrorData.status = error.status;
      dialogErrorData.message = error.message;
      dialogErrorData.error = error.error;
      dialogErrorData.url = error.url;
    }
    const dialogRef = this.dialog.open(TechErrorDialogComponent, {
      panelClass: ['col-xs-12', 'col-sm-8', 'col-md-6', 'col-lg-5', 'mw-500'],
      data: dialogErrorData,
    });
    return false;
  }

  public openErrorDialogLogin(
    title: string,
    content: string,
    error: HttpErrorResponse
  ): boolean {
    let dialogErrorData = new TechErrorDialogModel();
    dialogErrorData.title = title ? title : 'Error';
    dialogErrorData.content = content ? content : error.error.Message;
    dialogErrorData.code = error.error.Code;
    dialogErrorData.status = error.status;
    const dialogRef = this.dialog.open(TechErrorDialogComponent, {
      panelClass: ['col-xs-12', 'col-sm-8', 'col-md-6', 'col-lg-4'],
      maxWidth: '100vw',
      data: dialogErrorData,
    });
    return false;
  }

  //TechModalDialog
  public openModalDialog(
    icon: string,
    title: string,
    content: string,
    footer: string,
    panelclass?: any
  ): boolean {
    let dialogErrorData = new TechModalDialogModel();
    dialogErrorData.icon = icon || '';
    dialogErrorData.title = title; //(title)? title : 'Error';
    dialogErrorData.content = content;
    dialogErrorData.footer = footer || '';
    let panelClass = panelclass
      ? panelclass
      : ['col-xs-12', 'col-sm-8', 'col-md-6', 'col-lg-4'];
    const dialogRef = this.dialog.open(TechModalDialogComponent, {
      panelClass: panelClass,
      maxWidth: '100vw',
      data: dialogErrorData,
    });
    return false;
  }

  //TechConfirmaDialog
  public openConfirmDialog(options) {
    this.dialogRefConfirmation = this.dialog.open(
      TechConfirmationDialogComponent,
      {
        data: {
          title: options.title,
          message: options.message,
          cancelText: options.cancelText,
          confirmText: options.confirmText,
        },
      }
    );
  }

  //TechConfirmaDialog con panelClass
  public openConfirmDialogWidth(options) {
    this.dialogRefConfirmation = this.dialog.open(
      TechConfirmationDialogComponent,
      {
        data: {
          title: options.title,
          message: options.message,
          cancelText: options.cancelText,
          confirmText: options.confirmText,
        },
        panelClass: ['col-xs-12', 'col-sm-8', 'col-md-6', 'col-lg-4'],
      }
    );
  }

  public confirmedDialog(): Observable<any> {
    return this.dialogRefConfirmation.afterClosed().pipe(
      take(1),
      map((res) => {
        return res;
      })
    );
  }
}
